import React from 'react';
import AttachIcon from "../../../../../media/images/AttachIcon.mjs";
import appLib from "../../../../../libs/appLib.mjs";
import DownloadIcon from "../../../../../media/images/DownloadIcon.mjs";
import {Button} from "reactstrap";
import TrashIcon from "../../../../../media/images/TrashIcon.mjs";

const mapMime = (m) => {
	const [p,s] = m.toLowerCase().split("/");
	if ( s.startsWith("htm") ) return "HTML";
	if ( s.includes("spreadsheet") || s.includes("excel") ) return "Excel";
	if ( s.includes("word") ) return "Doc";
	if ( s.includes("powerpoint") || s.includes("presentation") ) return "PPoint";
	if ( p === 'video' ) return "Video";
	if ( p === 'audio' ) return "Audio";
	if ( p === 'image' ) return "Image";
	if ( s.includes(".") ) return s.split('.').pop().toUpperCase;
	return s.toUpperCase();
}
/*
			"text/plain": [".txt"],
			"text/rtf": [".rtf"],
			"text/xml": [".xml"],
			"text/html": [".htm", ".html"],
			"application/pdf": [".pdf"],
			"application/msword": [".doc"],
			"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
			"application/vnd.ms-excel": [".xls", ".xlsx"],
			"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
			"application/vnd.ms-powerpoint": [".ppt", ".pps"],
			"application/vnd.openxmlformats-officedocument.presentationml.presentation": [".pptx"],
			"application/vnd.openxmlformats-officedocument.presentationml.slideshow": [".ppsx"],
			"application/octet-stream": [".eml"],
			"application/x-rar-compressed": [".rar"],
			"application/zip": [".zip"]

 */
const AttachmentItem = class extends React.Component {
	render() {
		return(
			<tr>
				{ this.props.icon && (
					<td className={"icon"}>
						<AttachIcon/>
					</td>
				)}
				<td className={"name"}>
					{String(this.props.attachment.name).replace(/\.[^.]{1,5}$/,'') }
				</td>
				<td className={"type nomobile"}>
					{ mapMime(this.props.attachment?.type) }
				</td>
				{ this.props.size && (
					<td className={"size nomobile"}>
						{appLib.smartSize(this.props.attachment.size)}
					</td>
				)}
				{ this.props.onDownload && (
					<td className={"control download"}>
						<Button
							className={"btn-icon"}
							color="primary"
							onClick={ e => {
								e.preventDefault();
								if ( this.prop.attachment.id ) {
									appLib.downloadAttach(this.prop.attachment.id);
								} else {
									this.props.onDownload(this.props.attachment);
								}
							}}
						>
							<i>
								<DownloadIcon />
							</i>
						</Button>
					</td>
				)}
				{ this.props.onDelete && (
					<td className={"control delete"}>
						<Button
							className={"btn-icon"}
							color="warning"
							onClick={ e => {
								e.preventDefault();
								this.props.onDelete(this.props.attachment);
							}}
						>
							<i>
								<TrashIcon />
							</i>
						</Button>
					</td>
				)}
			</tr>
		);
	}
}

export default AttachmentItem;